import { render, staticRenderFns } from "./ReassuranceItems.vue?vue&type=template&id=654a124b&"
import script from "./ReassuranceItems.vue?vue&type=script&lang=js&"
export * from "./ReassuranceItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports